import React, {useMemo} from 'react';
import { Dropdown } from '@etiquette-ui/inputs-dropdowns';

const MIDDLE_DAY = 12;

const getTimeOptions = () => {
    let currentHour = 0;
    let currentMinute = 0;
    const endHour = 24;

    let timeOptions = [];

    while(true){

      const period = currentHour >= MIDDLE_DAY ? 'p.m.' : 'a.m.';
      const hour = currentHour > MIDDLE_DAY ? currentHour - MIDDLE_DAY : currentHour;

      const formattedHour = String(hour).padStart(2, '0');
      const formatedFullHour = String(currentHour).padStart(2,'0');
      const formattedMinute = String(currentMinute).padStart(2, '0');

      timeOptions.push({
        label: `${formattedHour}:${formattedMinute} ${period}`,
        value: `${formatedFullHour}:${formattedMinute}`
      });

      currentMinute += 30;
      if (currentMinute >= 60) {
        currentMinute -= 60;
        currentHour++;
      }

      if (currentHour >= endHour) {
        break;
      }

    }

    return timeOptions;
  };


const TimeSelector = ({value, setValue, label}) => {

  const timeOptions = getTimeOptions();

  const selectedOption = useMemo(()=>{
    if( !value ) return timeOptions[0];

    let option = timeOptions.find( option => option.value === value );
    
    if( !option ){
      const time = value.split(':');
      const hour = Number(time[0]);
      const period = hour >= MIDDLE_DAY ? 'p.m.' : 'a.m.';
      const formatedHour = String(hour <= MIDDLE_DAY ? time[0] : hour - MIDDLE_DAY).padStart(2,'0');
      option = {
        label: `${formatedHour}:${time[1]} ${period}`,
        value
      };
    }

    return option;
  },[value]);

  return (
    <Dropdown
      containerProps={{className: 'time-selector'}}
      labelProps={{
        label
      }}
      selectProps={{
        value: selectedOption,
        options: timeOptions,
        onChange: (option) => setValue(option.value),
        plaholder: '',
        inputId: 'searchInput',
      }}
    />
  )
}
export default TimeSelector;